// Copyright © 2021 Move Closer
import { getAbstractCheckListProps } from '../../_abstract';
/**
 * @author Stanisław Gregor <stanislaw.gregor@movecloser.pl>
 */
export const bootstrapCheckProps = {
    ...getAbstractCheckListProps(),
    className: {
        type: String,
        required: false
    }
};
